import { render, staticRenderFns } from "./flaggedOrders.vue?vue&type=template&id=24077ade"
import script from "./flaggedOrders.vue?vue&type=script&lang=js"
export * from "./flaggedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports